















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class OrderBulkActionModal extends Vue {
  @Prop({ required: true }) readonly name!: string;
  @Prop({ required: true }) readonly title!: string;
  @Prop({ required: true }) readonly text!: string;
  @Prop({ required: true }) readonly description!: string;
  @Prop({ default: '' }) readonly confirmClass!: string;
  @Prop({ default: () => [] }) readonly items!: string[];
  @Prop() readonly confirmText?: string;
  @Prop() readonly cancelText?: string;
}
